import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7a9a75f9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/pages/Documentacao/Views/stylesManual.scss?vue&type=style&index=0&id=7a9a75f9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9a75f9",
  null
  
)

export default component.exports